import { render, staticRenderFns } from "./cr_show.vue?vue&type=template&id=57fdd75a&"
import script from "./cr_show.vue?vue&type=script&lang=js&"
export * from "./cr_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57fdd75a')) {
      api.createRecord('57fdd75a', component.options)
    } else {
      api.reload('57fdd75a', component.options)
    }
    module.hot.accept("./cr_show.vue?vue&type=template&id=57fdd75a&", function () {
      api.rerender('57fdd75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_show.vue"
export default component.exports